module.exports = __webpack_public_path__ + "static/media/icon_autonomo_active.da9ae6a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_autonomo_active.svg
// module id = 324
// module chunks = 0